import { Directive, OnDestroy, OnInit, Self } from '@angular/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { Subscription } from 'rxjs';
import {
  applyMultiSelectTouchSelectFix,
  MultiSelectPopupInternals,
} from './multiselect-touch.select-fix';

/*
USAGE:            Applied to ALL <kendo-multiselect> in templates that import DropDownsModuleEx (UIModule does).
                  Makes a tapped list item select on iPad (Bug 34682); see multiselect-touch.select-fix.ts.

REMOVE:           when @progress/kendo-angular-dropdowns is upgraded to 23 or later.
 */
@Directive({
  selector: 'kendo-multiselect',
  standalone: false,
})
export class MultiSelectTouchSelectFixDirective implements OnInit, OnDestroy {
  private openedSubscription?: Subscription;

  constructor(@Self() private multiSelect: MultiSelectComponent) {}

  ngOnInit(): void {
    // Kendo creates a new popup element on every open, so the fix is applied per open.
    this.openedSubscription = this.multiSelect.opened.subscribe(() =>
      applyMultiSelectTouchSelectFix(
        this.multiSelect as unknown as MultiSelectPopupInternals
      )
    );
  }

  ngOnDestroy(): void {
    this.openedSubscription?.unsubscribe();
  }
}
